import { useContext } from "react";
import { UploaderContext } from "../providers/uploader-context";

export const useUploader = () => useContext(UploaderContext);
